<template>
    <div>
        <form class="flex flex-col mb-6">
            <button class="text-black flex justify-end mx-4" v-show="isDirty" @click.prevent="persistMe">
                <i class="fas fa-save fa-lg"></i>
            </button>
            <div class="w-full flex">
                <div class="modal-form-block">
                    <label>
                        {{ trans.get('production.date' )}}:
                    </label>
                    <div class="relative shadow-md p-3 border border-gray-300">
                        <div class="w-full">
                            {{ reverseDate(instruction.data_immissione) }}
                        </div>
                    </div>
                </div>
                <div class="modal-form-block">
                    <label>
                        {{ trans.get('production.code') }}:
                    </label>
                    <div>
                        <div class="shadow-md p-3 border border-gray-300">
                            {{instruction.codice}}
                        </div>
                    </div>
                </div>
                <div class="modal-form-block w-1/2">
                    <label>
                        Rev.:
                    </label>
                    <div>
                        <div class="shadow-md p-3 border border-gray-300">
                            {{instruction.revisione}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full flex modal-form-block">
                <label>
                    {{ trans.get('production.title' )}}:
                </label>
                <div class="flex relative">
                    <input class="shadow-md p-3 w-full"
                           type="text"
                           name="titolo"
                           v-model="activeInstruction.titolo"
                           @change="makeMeDirt"
                    >
                    <div class="w-5 flex items-center p-3 absolute right-0 justify-end">
                        <i class="fas fa-pencil-alt"></i>
                    </div>
                </div>
            </div>

            <div class="w-full modal-form-block">
                <label>
                    {{ trans.get('production.description' )}}:
                </label>
                <div class="flex relative">
                    <input class="shadow-md p-3 w-full"
                           type="text"
                           name="descrizione"
                           v-model="activeInstruction.descrizione"
                           @change="makeMeDirt"
                    >
                    <div class="w-5 flex items-center p-3 absolute right-0 justify-end">
                        <i class="fas fa-pencil-alt"></i>
                    </div>
                </div>
            </div>

            <div class="w-full flex">
                <div class="modal-form-block">
                    <label>
                        {{ trans.get('production.work_unit' )}}:
                    </label>
                    <div class="relative">
                        <select class="shadow-md p-3 border-b border-gray-300"
                                name="work_unit_id"
                                id="work_unit_id"
                                v-model="activeInstruction.work_unit_id"
                                @change="makeMeDirt"
                        >
                        <option v-for="workunit in workunits"
                                :key="workunit.id"
                                v-text="workunit.id_reparto + ' | ' + workunit.descrizione"
                                :value="workunit.id"
                        >
                        </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-form-tag"
                     v-if="instruction.reparti_interessati"
                >
                    <label>
                        {{ trans.get('production.wu_int') }}:
                    </label>
                    <input-tag class="shadow-md p-3"
                               type="text"
                               name="reparti_interessati"
                               v-model="repartiTags"
                               placeholder="Add a #tag!"
                               @update:tags="makeMeDirt"
                    />
                </div>
            </div>

            <div class="flex w-full justify-center">
                <div class="modal-form-tag w-64">
                    <label>
                        {{ trans.get('production.model' )}}:
                    </label>
                    <input-tag class="shadow-md p-3"
                               type="text"
                               name="modelli"
                               v-model="modelliTags"
                               placeholder="Add a #tag!"
                               @update:tags="makeMeDirt"
                    />
                </div>
                <div class="modal-form-tag w-56">
                    <label>
                        {{ trans.get('production.modifica_tecnica' )}}:
                    </label>
                    <input-tag class="shadow-md p-3"
                               type="text"
                               name="mod_tech"
                               v-model="modTechTags"
                               placeholder="Add a #tag!"
                               @update:tags="makeMeDirt"
                    />
                </div>
                <div class="modal-form-tag w-64">
                    <label>
                        {{ trans.get('production.pr_relate' )}}:
                    </label>
                    <input-tag class="shadow-md p-3"
                               type="text"
                               name="pr"
                               v-model="projectTags"
                               placeholder="Add a #tag!"
                               @update:tags="makeMeDirt"
                    />
                </div>
            </div>
            <div class="flex">
                <div class="flex flex-col modal-form-block">
                    <label>
                        {{ trans.get('production.url_video') }}:
                    </label>
                    <div class="flex relative">
                        <input class="shadow-md p-3 w-full"
                               type="text"
                               name="url_video"
                               v-model="activeInstruction.url_video"
                               @change="makeMeDirt"
                        >
                        <div class="w-5 flex items-center p-3 absolute right-0 justify-end">
                            <i class="fas fa-pencil-alt"></i>
                        </div>
                    </div>
                </div>
                <div class="w-1/6 mt-12 flex justify-center items-center">
                    <a :href="instruction.url_video" v-show="instruction.url_video" class="hover:text-blue-500">
                        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="youtube" class="svg-inline--fa fa-youtube fa-3x" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path></svg>
                    </a>
                </div>
            </div>
            <div class="flex"
                 v-show="instruction.url">
                <div class="flex flex-col w-full modal-form-block">
                    <label>
                        PDF Iop
                    </label>
                    <p class="break-all shadow-md p-3 border border-gray-300">
                        {{instruction.url}}
                    </p>
                </div>
                <a class="w-1/6 mt-16 flex justify-center items-center hover:text-blue-500"
                     v-show="instruction.url" :href="instruction.url" >
                    <a class="far fa-file-pdf fa-3x">
                    </a>
                </a>
            </div>
        </form>
    </div>
</template>

<script>
    import InputTag from 'vue-input-tag';

    export default {
        name: "ShowInstruction",

        components: {
            InputTag,
        },

        props: [
            'instruction',
        ],

        data() {
            return {
                activeInstruction: this.instruction,
                isDirty: false,
                dirtyThings: [],
                workunits: [],
                repartiTags: this.convertToTag(this.instruction.reparti_interessati),
                modelliTags: this.convertToTag(this.instruction.modelli),
                projectTags: this.convertToTag(this.instruction.pr),
                modTechTags: this.convertToTag(this.instruction.mod_tech)
            }
        },

        created() {
            axios.get('/workunits')
                .then(({data}) => this.workunits = data);
        },

        beforeMount() {
            window.addEventListener("beforeunload", this.preventNav);
            this.$once("hook:beforeDestroy", () => {
                window.removeEventListener("beforeunload", this.preventNav);
            })
        },
        methods: {
            reverseDate(date) {
                if (date != null) {
                    return date.split('-').reverse().join('/');
                }
            },

            makeMeDirt(e) {
                this.isDirty = true;
                if(!this.dirtyThings.includes(e.target.name)) {
                    this.dirtyThings.push(e.target.name)
                }
            },

            preventNav(event) {
                if (this.isDirty) {
                    event.preventDefault();
                    event.returnValue = "";
                }
            },

            persistMe() {
                let payload = Object.fromEntries(Object.entries(this.activeInstruction)
                    .filter(([key, value]) => this.dirtyThings.includes(key))
                );
                payload.reparti_interessati=JSON.stringify(this.repartiTags);
                payload.mod_tech=JSON.stringify(this.modTechTags);
                payload.pr=JSON.stringify(this.projectTags);
                payload.modelli=JSON.stringify(this.modelliTags);
                axios.patch(`/instructions/${this.activeInstruction.id}`, payload)
                    .then(() => {
                        this.$toastr.s('Instruction Updated Successfully');
                        this.isDirty = false;
                        window.location.href = '/instructions/';
                    })
                    .catch((e) => {
                        this.$toastr.e('Oh no there\'s something horribly wrong');
                    })
            },

            convertToTag(tagToConvert) {
                return JSON.parse(tagToConvert)
            }
        },
    }
</script>

<style scoped>

</style>